export default {
    computed: {
        $_networks() {
            return [
                {
                    url: this.currentUrl,
                    label: "Twitter",
                    name: "twitter",
                    title: `I thought you'd enjoy some of the key points in the hibooks Insight that I listened to today. Check out ${this.bookInsight.title} and let's chat!`,
                    iconPath: require("@assets/img/book-insights/icons/twitter-share-icon.svg")
                },
                {
                    url: this.currentUrl,
                    title: this.bookInsight.title,
                    label: "Facebook",
                    name: "facebook",
                    description: `While listening to this hibooks Insight, ${this.bookInsight.title}, I felt the need to share. Have a listen to hear some great points!`,
                    iconPath: require("@assets/img/book-insights/icons/facebook-share-icon.svg")
                },
                {
                    url: this.currentUrl,
                    title: this.bookInsight.title,
                    label: "Email",
                    name: "email",
                    description: `While listening to this hibooks Insight, I thought of you! There are some points in this Insight on ${this.bookInsight.title} that I thought you would find interesting.It's not too long, but packed with great knowledge. Have a listen, and let's chat when you're done!`,
                    iconPath: require("@assets/img/book-insights/icons/email-share-icon.svg")
                }
            ]
        },
        $_networkEvents() {
            const events = {
                twitter: {
                    event: "bi-conv-bookpage-sharetwitter",
                    action: "sharetwitter"
                },
                email: {
                    event: "bi-conv-bookpage-shareemail",
                    action: "shareemail"
                },
                facebook: {
                    event: "bi-conv-bookpage-sharefb",
                    action: "sharefb"
                },
                copylink: {
                    event: "bi-conv-bookpage-sharecopylink",
                    action: "sharecopylink"
                }
            }

            Object.keys(events).forEach((key) => {
                events[key].insightSlug = this.bookInsight.slug;
                events[key].insightGenre = this.bookInsight.genre.name;
            });

            return events;
        }
    }
}
